<template>
    <div class="page">
        <div class="page-hedaer line-bar-bottom">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item to="/system/account">账号设置</el-breadcrumb-item>
                <el-breadcrumb-item>修改密码</el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <div class="page-body form-page">
            <el-form :model="form" ref="form" :rules="rules" label-width="150px">
                <el-form-item label="原密码：" prop="oldPwd">
                    <el-input v-model="form.oldPwd" type="password" maxlength="12" placeholder="请输入原密码" clearable></el-input>
                    <el-button type="text" size="medium" @click="handleForget">找回密码</el-button>
                </el-form-item>

                <el-form-item label="新密码：" prop="newPwd">
                    <el-input v-model="form.newPwd" type="password" maxlength="12" placeholder="请输入6-12位数字与字符组合" clearable></el-input>
                </el-form-item>

                <el-form-item label="确认新密码：" prop="cfmPwd">
                    <el-input v-model="form.cfmPwd" type="password" maxlength="12" placeholder="请再次输入新密码" clearable></el-input>
                </el-form-item>

                <el-form-item>
                    <el-button
                        type="primary"
                        size="medium"
                        :disabled="!isFormSubmit"
                        :loading="sending"
                        @click="handleSubmit"
                    >保 存</el-button>
                    <el-button size="medium" @click="$router.go(-1)">取消</el-button>
                </el-form-item>
            </el-form>
        </div>

        <dialogForgetPassword ref="dialogForgetPassword" @success="handleLogout" />
    </div>
</template>

<script>
import { updatePassWord } from '@/api/account';
import { validatePassword } from '@/validate';
import dialogForgetPassword from './components/dialogForgetPassword';

export default {
  name: 'accountPasswordPage',
  components: {
    dialogForgetPassword,
  },
  data() {
    const validateNewPass = (rule, value, callback) => {
      if (value !== this.form.newPwd) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };

    return {
      sending: false,
      isFormSubmit: false,

      form: {
        oldPwd: '',
        newPwd: '',
        cfmPwd: '',
      },

      rules: {
        oldPwd: [{ required: true, validator: validatePassword, trigger: 'blur' }],
        newPwd: [{ required: true, validator: validatePassword, trigger: 'blur' }],
        cfmPwd: [
          { required: true, validator: validatePassword, trigger: 'blur' },
          { required: true, validator: validateNewPass, trigger: 'blur' },
        ],
      },
    };
  },
  watch: {
    form: {
      handler(value) {
        let tmpPass = true;

        Object.keys(value).forEach((key) => {
          if (value[key] === '') {
            tmpPass = false;
          }
        });

        this.isFormSubmit = tmpPass;
      },
      deep: true,
    },
  },
  created() {},
  mounted() {},
  methods: {
    // 提交
    handleSubmit() {
      if (this.sending) {
        return false;
      }

      this.$refs.form.validate((valid) => {
        if (valid) {
          this.sending = true;

          updatePassWord({
            sysUserId: this.$store.getters.userId,
            oldPwd: this.$md5(this.form.oldPwd),
            newPwd: this.$md5(this.form.newPwd),
          })
            .then(() => {
              this.sending = false;

              this.$message({
                type: 'success',
                message: '密码修改成功！',
              });

              // 退出登录
              this.handleLogout();
            })
            .catch(() => {
              this.sending = false;
            });
        }
      });
    },

    // 忘记密码
    handleForget() {
      this.$refs.dialogForgetPassword.handleOpen();
    },

    // 退出登录
    handleLogout() {
      this.$store.dispatch('LogOut').then(() => {
          setTimeout(() => {
            this.$router.push({ path: '/login' });
          }, 1500);
      }).catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped></style>
